/**
 * @file  audit/audit.model.ts
 * @description  site audit information
 *
 * @author ogarcia (ozkary)
 *
 */

import { BaseCustomer } from '../customer/customer.model';
import { Vehicle } from '../vehicle/vehicle.model';

/**
 * app audit status to track the activity
 */
export enum AuditStatus {
  visit = 'visit',
  timeout = 'timeout',
  abandon = 'abandon',
  complete = 'receipt'
}

/**
 * audit information
 */
export interface Audit {
  id: number;
  customer?: BaseCustomer;
  vehicle?: Vehicle;
  status: string;
  created: string;
  updated?: string;
  pageView: string[];
  refId?: string;
  domain: string;
  edition: string;
  token?: string;
  _id?: string;
}
